<template>
  <router-view />
</template>

<script>
import { provide, onMounted, onBeforeUnmount } from "vue"
import store from "@/store"
import { useRouter } from "vue-router"
import firebase from "firebase/compat/app"
import "firebase/compat/auth"
import {
  createIdleSessionManager,
  getSecurityPolicyConfig
} from "@/utils/securityPolicy"

export default {
  setup() {
    provide('store', store)

    const router = useRouter()
    let authUnsubscribe = null
    let idleSessionManager = null

    const stopIdleSessionManager = () => {
      if (idleSessionManager) {
        idleSessionManager.stop()
        idleSessionManager = null
      }
    }

    const startIdleSessionManager = () => {
      stopIdleSessionManager()

      const { idleTimeoutMinutes } = getSecurityPolicyConfig()
      if (!idleTimeoutMinutes) {
        return
      }

      idleSessionManager = createIdleSessionManager({
        idleTimeoutMinutes,
        onTimeout: async () => {
          stopIdleSessionManager()
          await firebase.auth().signOut().catch(() => {})
        }
      })

      idleSessionManager.start()
    }

    onMounted(() => {
      authUnsubscribe = firebase.auth().onAuthStateChanged((user) => {
        if (!user) {
          stopIdleSessionManager()

          if (router.currentRoute.value.meta.requiresAuth) {
            router.replace("/Login")
          }

          return
        }

        startIdleSessionManager()

        if (router.currentRoute.value.path === "/Login") {
          router.replace("/")
        }
      })
    })

    onBeforeUnmount(() => {
      stopIdleSessionManager()

      if (typeof authUnsubscribe === "function") {
        authUnsubscribe()
      }
    })
  }
};
</script>
<style></style>
